import { createApp, provide, h } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import "@/core/plugins/prismjs";
import "bootstrap";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { provideApolloClient } from "@vue/apollo-composable";
import { toastOptions } from "./config/toastOptions";
import { apolloClient } from "./config/apolloClient";
import { VZIntersect } from "./directive/IntersectionObserver";
import maska from "maska";
import mitt from "mitt";
import PrimeVue from "primevue/config";
import ContextMenu from "primevue/contextmenu";
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import VueTelInput from "vue3-tel-input";
import "vue3-tel-input/dist/vue3-tel-input.css";
import VueTippy from "vue-tippy";
const VueTelInputOptions = {
  mode: "international",
  // onlyCountries: ["NG", "GH", "GB", "US", "CA"],
};
const emitter = mitt();
const app = createApp(App);

// Provide the Apollo Client instance
provideApolloClient(apolloClient);

app.use(Toast, toastOptions);
app.use(VueTelInput, VueTelInputOptions); // Define default global options here (optional)
app.use(store);
app.use(router);
app.use(PrimeVue);
app.use(ElementPlus);
app.component("ContextMenu", ContextMenu);
app.directive("vz-intersect", VZIntersect);
app.provide("emitter", emitter);
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);
app.use(maska);
app.use(VueTippy);
// {
//   directive: "tippy", // => v-tippy
//   component: "tippy", // => <tippy/>
// }
app.mount("#app");
